import {
  mdiAccountCardDetails,
  mdiFileDocumentBox,
  mdiBookOpenPageVariant
} from "@mdi/js";
import { MenuListItem, IMenuList } from "../../../model";

export enum sponsorMenuItemCategories {
  General = "General",
  Studies = "Studies",
  Programs = "Programs"
}

export class SponsorMenuContainer implements IMenuList {
  // This will be the interface structure used for the component to make it generic
  public menuItems: MenuListItem[];
  public constructor() {
    this.menuItems = this.getMenu();
  }

  public getMenu() {
    const menuList = [
      new MenuListItem(
        "General Info",
        mdiAccountCardDetails,
        "/sponsor/:id",
        sponsorMenuItemCategories.General
      ),
      new MenuListItem(
        "Studies",
        mdiFileDocumentBox,
        "/sponsor/:id/study",
        sponsorMenuItemCategories.Studies
      ),
      new MenuListItem(
        "Programs",
        mdiBookOpenPageVariant,
        "/sponsor/:id/program",
        sponsorMenuItemCategories.Programs
      )
    ];

    return menuList;
  }
}
